import { AgentTemplateStore } from "@/components/agents/templates/agent-template-store.tsx";
import { m } from "@/paraglide/messages.js";
import { createFileRoute } from "@tanstack/react-router";
import { pageTitle } from "@/utils/page-title.ts";

export const Route = createFileRoute(
	"/_authenticated/dashboard/agents/templates",
)({
	component: AgentTemplateStore,
	head: () => ({
		meta: [{ title: pageTitle(m.agent_templates_title()) }],
	}),
});
